// @ts-nocheck
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Loader2, Trophy } from "lucide-react";

export default function CircuitsIndexPage() {
  const { data: circuits = [], isLoading } = useQuery({
    queryKey: ["public-circuits"],
    queryFn: async () => {
      const { data } = await (supabase as any)
        .from("circuits")
        .select("id,name,slug,circuit_type,age_group,gender,season,description,logo_url")
        .eq("is_public", true)
        .eq("is_active", true)
        .order("name");
      return data || [];
    },
  });

  return (
    <div className="container mx-auto px-4 py-12 max-w-6xl">
      <header className="mb-10 text-center">
        <h1 className="text-4xl font-bold tracking-tight flex items-center justify-center gap-3">
          <Trophy className="w-8 h-8 text-primary" /> Circuits
        </h1>
        <p className="text-muted-foreground mt-3 max-w-2xl mx-auto">
          Track standings, scoring, and live-period events across the season.
        </p>
      </header>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
        </div>
      ) : circuits.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">
          No public circuits available right now.
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {circuits.map((c: any) => (
            <Link
              key={c.id}
              to={`/circuits/${c.slug}`}
              className="block p-6 border rounded-xl bg-card hover:shadow-md hover:border-primary/40 transition-all"
            >
              <div className="font-bold text-lg">{c.name}</div>
              <div className="text-xs text-muted-foreground mt-1">
                {[c.circuit_type, c.age_group, c.gender, c.season]
                  .filter(Boolean)
                  .join(" · ")}
              </div>
              {c.description && (
                <p className="text-sm mt-3 text-muted-foreground line-clamp-3">
                  {c.description}
                </p>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
